module.exports = __webpack_public_path__ + "static/media/55.3259e3f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/55.png
// module id = 628
// module chunks = 0